import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import CartSidebar from './CartSidebar'

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height
  }
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

const ConcessionsCartSidebar = ({ history, clearCart, hasCartItems, discountsAvailable, noOpTenders, signatureRequired, className, setMenus, stands, menu, tipSuggestions, cashEnabled, networkAvailable, ticketEnabled }) => {
  const [showCardReaderModal, setShowCardReaderModal] = useState(false)
  const { width } = useWindowDimensions()

  const onCardPayment = () => {
    if (signatureRequired || !isEmpty(tipSuggestions)) {
      history.push('/signature')
    } else {
      setShowCardReaderModal(true)
    }
  }

  const topButton = {
    text: "Card",
    disabled: !hasCartItems,
    onClick: onCardPayment,
  }

  const bottomButton = {
    text: "Cash",
    disabled: !hasCartItems,
    onClick: () => history.push('/change-calculator')
  }

  const onMobileWallet = () => {
    history.push('/rich-checkout')
  }

  return (
    <CartSidebar
      topButton={topButton}
      clearCart={clearCart}
      bottomButton={bottomButton}
      hasCartItems={hasCartItems}
      showCardReaderModal={showCardReaderModal}
      onCardReaderModalClose={setShowCardReaderModal}
      onMobileWallet={onMobileWallet}
      className={className}
      discountsAvailable={discountsAvailable}
      noOpTenders={noOpTenders}
      history={history}
      setMenus={setMenus}
      stands={stands}
      menu={menu}
      cashEnabled={cashEnabled}
      networkAvailable={networkAvailable}
      ticketEnabled={ticketEnabled && networkAvailable}
      tipEnabled={!isEmpty(tipSuggestions)}
    />
  )
}

export default withRouter(ConcessionsCartSidebar)
